import { FC, useMemo } from 'react';
import { css } from '@bts-web/utils-style-engine';

const CheckboxSingle: FC<{
  checked?: boolean;
  onChange?: () => void;
  name?: string;
  label?: string;
  disabled?: boolean;
}> = ({ onChange, checked, label, name, disabled }) => {
  const uniqueId = useMemo(() => {
    return `checkbox-${Math.random().toString(36).substr(2, 9)}`;
  }, []);

  return (
    <label
      className={css({
        display: 'block',
        position: 'relative',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: '22px',
        userSelect: 'none',
        lineHeight: 1,
        _hover: {
          '& .checkmark': {
            backgroundColor: disabled ? '#eee' : '#ccc',
          },
        },
      })}
      htmlFor={uniqueId}
    >
      {label}
      <input
        id={uniqueId}
        type="checkbox"
        name={name}
        checked={checked || false}
        disabled={disabled}
        className={css({
          position: 'absolute',
          opacity: 0,
          cursor: 'pointer',
          height: 0,
          width: 0,
        })}
        onChange={() => {
          if (!disabled) {
            onChange?.();
          }
        }}
      />
      <span
        className={css({
          display: 'inline-block',
          position: 'relative',
          height: '28px',
          width: '28px',
          lineHeight: 1,
          backgroundColor: disabled ? '#f0f0f0' : 'transparent',
          borderRadius: '4px',
          border: '2px solid rgba(0, 0, 0, 0.35)',
          _after: {
            content: '""',
            lineHeight: 1,
            position: 'absolute',
            display: checked ? 'block' : 'none',
            insetInlineStart: '8px',
            top: '3px',
            width: '8px',
            height: '15px',
            border: 'solid white',
            borderWidth: '0 3px 3px 0',
            transform: 'rotate(45deg)',
          },
          ...(checked && {
            backgroundColor: 'rgba(0, 0, 0, 0.65)',
          }),
        })}
      />
    </label>
  );
};

export { CheckboxSingle };
